import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';

// Importar páginas
import HomePage from '../pages/HomePage.vue';

// Módulo financiero (Fase 1)
const FinancialWizardView = () => import('../views/financial/FinancialWizardView.vue');
const FinancialDashboardView = () => import('../views/financial/FinancialDashboardView.vue');
const FinancialHistoryView = () => import('../views/financial/FinancialHistoryView.vue');
const FinancialAnalysisHistoryView = () => import('../views/financial/FinancialAnalysisHistoryView.vue');
const FinancialAnalysisDetailView = () => import('../views/financial/FinancialAnalysisDetailView.vue');
const StatutoryComplianceView = () => import('../views/financial/StatutoryComplianceView.vue');
const BusinessViabilityView = () => import('../views/financial/BusinessViabilityView.vue');
const FinancialDocumentCenterView = () => import('../views/financial/FinancialDocumentCenterView.vue');
const FinancialDocumentDetailView = () => import('../views/financial/FinancialDocumentDetailView.vue');
import LoginPage from '../pages/LoginPage.vue';
import AgentsPage from '../pages/AgentsPage.vue';
import ChatPage from '../pages/ChatPage.vue';
import DashboardPage from '../pages/DashboardPage.vue';
import PlansPage from '../pages/PlansPage.vue';
import TenantsPage from '../pages/TenantsPage.vue';
import CredentialsPage from '../pages/CredentialsPage.vue';
import CustomPaymentPage from '../pages/CustomPaymentPage.vue';
import PaymentSuccessPage from '../pages/PaymentSuccessPage.vue';
import PaymentCancelPage from '../pages/PaymentCancelPage.vue';
import TenantProfilePage from '../pages/TenantProfilePage.vue';
import PaymentsDashboardPage from '../pages/admin/PaymentsDashboardPage.vue';
import CustomPaymentsAdminPage from '../pages/admin/CustomPaymentsAdminPage.vue';
import AgentsAdminPage from '../pages/admin/AgentsAdminPage.vue';
import PlansManagementPage from '../pages/admin/PlansManagementPage.vue';
import PromptManagementPage from '../pages/admin/PromptManagementPage.vue';
import UsagePage from '../pages/UsagePage.vue';
import ForgotPasswordPage from '../pages/ForgotPasswordPage.vue';
import ResetPasswordPage from '../pages/ResetPasswordPage.vue';
import OAuthCallbackPage from '../pages/OAuthCallbackPage.vue';
import PaymentHistoryPage from '../pages/PaymentHistoryPage.vue';
import IntegrationEventsPage from '../pages/IntegrationEventsPage.vue';
import CompanySignupPage from '../pages/CompanySignupPage.vue';
import OrchestratorPage from '../pages/OrchestratorPage.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
      meta: { requiresAuth: true },
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: { requiresGuest: true },
    },
    {
      path: '/suscribirse',
      alias: ['/subscribe'],
      name: 'company-signup',
      component: CompanySignupPage,
      meta: { requiresGuest: true },
    },
    {
      path: '/agents',
      name: 'agents',
      component: AgentsPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/chat/:agentId',
      name: 'chat',
      component: ChatPage,
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/usage',
      name: 'usage',
      component: UsagePage,
      meta: { requiresAuth: true },
    },
    {
      path: '/plans',
      name: 'plans',
      component: PlansPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/payment-history',
      name: 'payment-history',
      component: PaymentHistoryPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/integrations/events',
      name: 'integration-events',
      component: IntegrationEventsPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/tenants',
      name: 'tenants',
      component: TenantsPage,
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/credentials',
      name: 'credentials',
      component: CredentialsPage,
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/custom-payment',
      name: 'custom-payment',
      component: CustomPaymentPage,
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/payment/success',
      name: 'payment-success',
      component: PaymentSuccessPage,
    },
    {
      path: '/payment/cancel',
      name: 'payment-cancel',
      component: PaymentCancelPage,
    },
    {
      path: '/profile',
      name: 'profile',
      component: TenantProfilePage,
      meta: { requiresAuth: true },
    },
    {
      path: '/admin/payments',
      name: 'admin-payments',
      component: PaymentsDashboardPage,
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/plans',
      name: 'admin-plans',
      component: PlansManagementPage,
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/custom-payments',
      name: 'admin-custom-payments',
      component: CustomPaymentsAdminPage,
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/prompts',
      name: 'admin-prompts',
      component: PromptManagementPage,
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/agents',
      name: 'admin-agents',
      component: AgentsAdminPage,
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPasswordPage,
      meta: { requiresGuest: true },
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPasswordPage,
    },
    {
      path: '/oauth/callback',
      name: 'oauth-callback',
      component: OAuthCallbackPage,
    },
    // ── Orquestador Central ────────────────────────────────────────────────
    {
      path: '/orchestrator',
      name: 'orchestrator',
      component: OrchestratorPage,
      meta: { requiresAuth: true },
    },
    // ── Módulo financiero (Fase 1) ──────────────────────────────────────────
    {
      path: '/financial/wizard',
      name: 'financial-wizard',
      component: FinancialWizardView,
      meta: { requiresAuth: true },
    },
    {
      path: '/financial/dashboard/:documentId',
      name: 'financial-dashboard',
      component: FinancialDashboardView,
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: '/financial/history',
      name: 'financial-history',
      component: FinancialHistoryView,
      meta: { requiresAuth: true },
    },
    {
      path: '/financial/analysis-history',
      name: 'financial-analysis-history',
      component: FinancialAnalysisHistoryView,
      meta: { requiresAuth: true },
    },
    {
      path: '/financial/analysis-history/:analysisRunId',
      name: 'financial-analysis-history-detail',
      component: FinancialAnalysisDetailView,
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: '/financial/statutory-compliance',
      name: 'financial-statutory-compliance',
      component: StatutoryComplianceView,
      meta: { requiresAuth: true },
    },
    {
      path: '/financial/business-viability',
      name: 'financial-business-viability',
      component: BusinessViabilityView,
      meta: { requiresAuth: true },
    },
    {
      path: '/financial/document-center',
      name: 'financial-document-center',
      component: FinancialDocumentCenterView,
      meta: { requiresAuth: true },
    },
    {
      path: '/financial/document-center/:documentId',
      name: 'financial-document-detail',
      component: FinancialDocumentDetailView,
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
});

// Guard para autenticación
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  // Cargar usuario si hay token
  if (localStorage.getItem('token') && !authStore.user) {
    await authStore.loadUser();
  }

  // Rutas que requieren autenticación
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login');
    return;
  }

  // Rutas que requieren no estar autenticado (ej: login)
  if (to.meta.requiresGuest && authStore.isAuthenticated) {
    next('/');
    return;
  }

  // Rutas que requieren ser admin
  if (to.meta.requiresAdmin && !authStore.isAdmin) {
    next('/');
    return;
  }

  next();
});

export default router;
